import RowHeading from './RowHeading.js'
import Row from './Row.js'
import './styles.scss'

export default {
    rowHeading: RowHeading,
    row: Row,
}
